import { useSelected, useFocused } from 'slate-react';
import type { RenderElementPropsFor } from '../../../../types';
import type { LinkElement } from '../../types';
import LinkBase from '../link-base';

export type LinkElementProps = RenderElementPropsFor<LinkElement>;

export default function LinkElementComponent({
  attributes,
  element,
  children,
}: LinkElementProps) {
  const selected = useSelected();
  const focused = useFocused();

  return (
    <LinkBase selected={selected && focused} href={element.url} {...attributes}>
      {children}
    </LinkBase>
  );
}
